// extracted by mini-css-extract-plugin
module.exports = {"link":"AlpInfoRowHolder_link__Buzax","linkIcon":"AlpInfoRowHolder_linkIcon__2uwHB","loading":"AlpInfoRowHolder_loading__1EIhT"};